import { ChangeEvent, useEffect, useState } from 'react'
import { RhyBusAnnouncementsInnerview } from '@rhybus/announcements'
import { RhyBusInputText } from '@rhybus/form-controls'
import { RhyBusPageHeader } from '@rhybus/header'
import { getAnnouncementData } from '../../services/announcements'
import { getTags, innerViewFields, searchFields } from '../../config/configuration'
import PageOverlay from '../../utils/controls/pageoverLay/pageoverLay'

export default function Announcements() {
    const [searchValue, setSearchValue] = useState('')
    const [announcementItems, setAnnouncementItems] = useState<any[]>([])
    const [isLoading, setIsLoading] = useState(true)
    useEffect(() => {
        getAnnouncementData().then(setAnnouncementItems).finally(() => setIsLoading(false))
    }, [])
    const [filteredItems, setFilteredItems] = useState<any[]>([])
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setSearchValue(event.target.value)
    }
    return (
        <main id="main-content">
            {isLoading && <PageOverlay />}
            <RhyBusPageHeader
                pageTitle={'Announcements'}
                badgeCount={filteredItems?.length}
                pageHeaderIcon="icon-rb-announcement-mic"
                headerRightContent={
                    <div className="d-flex align-items-center justify-content-end">
                        <label htmlFor="announcements-search" className="sr-only">Search announcements</label>
                        <RhyBusInputText
                            id="announcements-search"
                            type='search'
                            iconRight={true}
                            wrapperClassName='min-w-250'
                            customIcon="icon-rb-search"
                            placeholder="Search Announcements"
                            value={searchValue}
                            onChange={handleChange}
                        />
                    </div>
                }
            />
            <div className='rb-innerview-pages'>
                <RhyBusAnnouncementsInnerview
                    items={announcementItems}
                    searchFields={searchFields}
                    getTags={getTags}
                    innerViewFields={innerViewFields}
                    searchText={searchValue}
                    cardSize="lg"
                    onFilteredItemsChange={(items: any) => setFilteredItems(items)}
                />
            </div>
        </main>
    )
}